import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Avatar, AvatarGroup } from '../Avatar';
import { Content, ContentWrapper } from '../Content';
import { avatars, cards as cardsData, reviewStars } from './data';
import * as Styled from './Statistics.styles';

const Statistics = () => {
  const { t } = useTranslation();

  const cards = useMemo(
    () =>
      cardsData.map((card) => ({
        ...card,
        label: t(`homeStatistics.cards.${card.key}.label`),
        text: t(`homeStatistics.cards.${card.key}.text`, { defaultValue: '' }),
      })),
    [t],
  );

  return (
    <Styled.Statistics id="statistics">
      <ContentWrapper>
        <Content
          labels={[t('homeStatistics.label')]}
          title={t('homeStatistics.title')}
        />

        <Styled.Cards>
          {cards.map(({ key, value, label, text }, index) => (
            <Styled.Card key={key} className="glass-border">
              {text && <Styled.Text variant="body16">{text}</Styled.Text>}

              <Styled.Bottom>
                <Styled.Info>
                  {value && <Styled.Value variant="h3">{value}</Styled.Value>}

                  <Styled.InfoSub>
                    {index === 0 && (
                      <AvatarGroup>
                        {avatars.map((avatar) => (
                          <Avatar key={avatar} icon={avatar} />
                        ))}
                      </AvatarGroup>
                    )}

                    {label && (
                      <Styled.Label variant="body16">{label}</Styled.Label>
                    )}
                  </Styled.InfoSub>
                </Styled.Info>

                {index === cards.length - 2 && (
                  <Styled.Review>
                    <Styled.Stars>
                      {Array.from({ length: reviewStars.value }).map(
                        (_, starIndex) => (
                          <Styled.Star
                            key={starIndex}
                            src={reviewStars.src}
                            alt={t('homeStatistics.starAlt')}
                          />
                        ),
                      )}
                    </Styled.Stars>

                    <Styled.Label variant="body16">
                      {t('homeStatistics.reviewText')}
                    </Styled.Label>
                  </Styled.Review>
                )}
              </Styled.Bottom>
            </Styled.Card>
          ))}
        </Styled.Cards>
      </ContentWrapper>
    </Styled.Statistics>
  );
};

export default Statistics;
